import { BatchableSprite } from '../../sprite/BatchableSprite';

/** @internal */
export class BatchableText extends BatchableSprite
{
    public currentKey: string;
}
